/**
 * 弹出框模块
 */

define(function(require, exports, module) {

    var Layer = require('c-layer');
    var Mask = require('c-mask');

    var templateList = [
        '<div class="widget-poplayer">',
            '<span class="widget-poplayer-close" data-id="close">×</span>',
            '<div class="widget-poplayer-content">{{content}}</div>',
        '</div>'
    ];


    var PopLayer = Layer.extend({

        defaults: {
            template: templateList.join(''),
            content: ''
        },

        initialize: function() {
            var self = this;

            self.mask = new Mask({
                hideWhenTap: 0
            });
            self.Parent(self, arguments);
        },

        create: function() {
            var self = this;
            let content = this.get('content');
            let template = this.get('template');
            
            self.set('template', template.replace('{{content}}', content));
            
            self.mask.create();

            self.Parent.apply(self, arguments);
            self.fixPostion();
            self.bindEvent();
        },

        fixPostion: function() {
            var el = this.get('el');
            
            el.css({
                'margin-left': '-' + el.width() / 2 + 'px',
                'margin-top': '-' + el.height() / 2 + 'px',
            });
        },
        bindEvent: function() {
            var self = this;
            var el = this.get('el');

            el.on('click', '[data-id=close]', function() {
                self.emit('close');
                self.destroy();
                self.mask.destroy();
            });

            self.mask.on('destroy', function() {
                el.remove();
            });
        }

    });

    //UpAct.PopLayer = PopLayer;

    module.exports = PopLayer;
});



// WEBPACK FOOTER //
// ./js/lib/poplayer/index.js